var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    [
      _c("wa-page-header", {
        key: "header",
        attrs: { slot: "header" },
        slot: "header",
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "app-content",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c(
            "section",
            {
              staticClass: "padding-top-5xl",
              staticStyle: {
                overflow: "hidden",
                "background-color": "var(--white)",
              },
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c("hero"),
                  _vm._v(" "),
                  _c(
                    "nav",
                    { staticClass: "tabs" },
                    [
                      _c(
                        "site-link",
                        {
                          staticClass: "tab",
                          attrs: {
                            to: { name: "leaderboard.new" },
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v6.solid.faIcons },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs",
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Top Requested"),
                              ]),
                              _vm._v("\n              Icons\n            "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "site-link",
                        {
                          staticClass: "tab",
                          attrs: {
                            to: { name: "leaderboard.brands" },
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v6.brands.faFontAwesome },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs",
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Top Requested"),
                              ]),
                              _vm._v("\n              Brands\n            "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "site-link",
                        {
                          staticClass: "tab",
                          attrs: {
                            to: { name: "leaderboard.inprogress" },
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v6.solid.faCompassDrafting },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs",
                            },
                            [_vm._v("In Progress")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "site-link",
                        {
                          staticClass: "tab",
                          attrs: {
                            to: { name: "leaderboard.released" },
                            "active-class": "active",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v6.solid.faSparkles },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs",
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Top Requested Icons that Have Been"),
                              ]),
                              _vm._v("\n              Released\n            "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container padding-top-4xl padding-bottom-7xl" },
            [
              _c(
                "div",
                {
                  staticClass: "margin-bottom-6xl",
                  staticStyle: {
                    "--table-striped-row-background": "var(--white)",
                    "--table-cell-border-color": "var(--white)",
                  },
                },
                [_c("router-view")],
                1
              ),
              _vm._v(" "),
              _c("sock"),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }